import Box from "@mui/material/Box";
import React, { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import { Menu, Typography } from "@mui/material";
import { FormikValues, useFormikContext } from "formik";

import Button from "../../../common/Button";

import { patientSx } from "../styles";
import styles from "../styles.module.scss";

interface ISecondPopupProps {
  filterType: string;
  isShowUserSelectModal: null | HTMLElement;
  setIsShowUserSelectModal: (value: HTMLElement | null) => void;
  handleCloseUserSelectModal: (value: any) => void;
}

const FilterSecondPopup: React.FC<ISecondPopupProps> = ({
  filterType,
  isShowUserSelectModal,
  setIsShowUserSelectModal,
  handleCloseUserSelectModal,
}) => {
  const [isAllChecked, setIsAllChecked] = useState(false);
  const allIndex = -1;
  const { values, setFieldValue } = useFormikContext<FormikValues>();

  const checkHandler =
    (index: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
      const isChecked = e?.target?.checked;
      if (index === allIndex) {
        const allCheckedValue = values?.[filterType]?.map((item: any) => ({
          ...item,
          isChecked: isChecked,
        }));
        setIsAllChecked(isChecked);
        setFieldValue(filterType, allCheckedValue);
      }
      if (index >= 0) {
        const prevValue = [...values?.[filterType]];
        prevValue[index] = { ...prevValue[index], isChecked };
        setFieldValue(filterType, prevValue);
      }
    };

  return (
    <Box sx={patientSx.secondPopContainer}>
      <Menu
        id="menu-appbar"
        anchorEl={isShowUserSelectModal}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={Boolean(isShowUserSelectModal)}
        onClose={handleCloseUserSelectModal}
      >
        <Typography sx={{ padding: "10px 20px" }}>
          <b>Select Users</b>
        </Typography>
        <hr />
        <Box sx={patientSx.secondPopupCheckbox}>
          <Box>
            <span className={styles.selectTitle}>All</span>
          </Box>
          <Checkbox
            checked={isAllChecked}
            onChange={checkHandler(allIndex)}
            sx={patientSx.checkBoxFill}
          />
        </Box>
        <Box className={styles.userListContainer}>
          {values?.[filterType]?.length > 0 &&
            values?.[filterType]?.map((item: any, index: number) => (
              <Box
                key={item?._id}
                sx={patientSx.secondPopupCheckbox}
              >
                <Box>
                  <span className={styles.selectTitle}>{item?.name}</span>
                  <span className={styles.selectSub}>
                    (Id:{item?.ID?.toUpperCase()})
                  </span>
                </Box>
                <Checkbox
                  checked={item?.isChecked}
                  onChange={checkHandler(index)}
                  sx={patientSx.checkBoxFill}
                />
              </Box>
            ))}
        </Box>
        <Box sx={patientSx.secondPopupCheckbox}>
          <Button
            color="alert"
            type="button"
            onClick={handleCloseUserSelectModal}
          >
            Ok
          </Button>
        </Box>
      </Menu>
    </Box>
  );
};

export default FilterSecondPopup;
